import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[avenirDigitOnly]',
  standalone: true
})
export class DigitOnlyDirective {
  constructor(private el: ElementRef) {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    // Allow navigation keys: backspace, delete, tab, escape, enter, home, end, left, right
    if ([46, 8, 9, 27, 13, 35, 36, 37, 39].indexOf(event.keyCode) !== -1 ||
        // Allow Ctrl/Cmd+A, Ctrl/Cmd+C, Ctrl/Cmd+V, Ctrl/Cmd+X
        (event.keyCode === 65 && (event.ctrlKey || event.metaKey)) ||
        (event.keyCode === 67 && (event.ctrlKey || event.metaKey)) ||
        (event.keyCode === 86 && (event.ctrlKey || event.metaKey)) ||
        (event.keyCode === 88 && (event.ctrlKey || event.metaKey))) {
      return;
    }

    // Ensure that it is a number and stop the keypress if it is not
    if ((event.shiftKey || (event.keyCode < 48 || event.keyCode > 57)) && (event.keyCode < 96 || event.keyCode > 105)) {
      event.preventDefault();
    }
  }

  // Handle copy/paste events
  @HostListener('input', ['$event']) onInput(event: Event) {
    const input = this.el.nativeElement as HTMLInputElement;
    let sanitized = input.value.replace(/[^0-9]/g, ''); // Remove non-digit characters
    if (sanitized.length > 2) {
      sanitized = sanitized.slice(0, 2);
    }
    input.value = sanitized;
  }
}
